<template>
  <Container type="card-full">
    <div slot="header" v-if="type === 1 || type === 2">
      <el-button @click="addOrEdit" :loading="btnLoading">保存</el-button>
    </div>
    <div>
      <div class="main">
        <el-form :model="project" ref="ruleForm" label-position="right" class="mainfrom">
          <div class="from_input">
            <div class="row">
            <el-form-item label="平台编号">
              <el-input v-model="project.projectno" :maxlength="20" show-word-limit :disabled="true" ></el-input>
            </el-form-item>
            <el-form-item label="项目类型">
              <el-select v-model="project.projecttype" :disabled="disable">
                <el-option label="代采项目" value="1"></el-option>
                <el-option label="自采项目" value="2"></el-option>
              </el-select>
              </el-form-item>
            </div>
            <div class="row" v-if="project.projecttype === '1'">
              <el-form-item label="代理机构" prop="projectacomid" verify>
                <el-select v-model="project.projectacomid" :disabled="true" @change="getaUserList">
                  <el-option v-for="(item, index) in acomList" :label="item.label" :value="item.value"
                             :key="index"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="联系人" prop="projectauserid" verify>
                <el-select v-model="project.projectauserid" :disabled="true" @change="getaUserTel">
                  <el-option v-for="(item, index) in auserList" :label="item.label" :value="item.value"
                             :key="index"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="联系电话" prop="projectatel" verify>
                <el-input v-model="project.projectatel" :maxlength="20" show-word-limit :disabled="true"></el-input>
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="项目编号" prop="projectcode" :verify="validateProjectcode">
                <el-input v-model="project.projectcode" :maxlength="40" show-word-limit :disabled="disable"></el-input>
              </el-form-item>
              <el-form-item label="采购品目" prop="projectchargefeetype" verify>
                <el-cascader  v-model="pmids" :disabled="disable" :filterable ="true" :options="pmList" size="medium" @change="pmchange"
                ></el-cascader>
              </el-form-item>
              <el-form-item label="业务员" verify prop="projectsuserid" v-if="project.projecttype === '2'">
                  <el-select v-model="project.projectsuserid" :clearable="true" :disabled="disable">
                    <el-option v-for="(item, index) in comsuserList" :label="item.username" :value="item.userid"
                              :key="index"></el-option>
                  </el-select>
              </el-form-item>
            </div>
          </div>
          <!--          <div class="content">-->
          <!--            <el-form-item label="采购内容">-->
          <!--              &lt;!&ndash;t&ndash;&gt;-->
          <!--              <el-input show-word-limit :maxlength="1024" type="textarea" :autosize="{ minRows: 2}" :disabled="disable"-->
          <!--                        v-model.trim="project.projectdesc"></el-input>-->
          <!--            </el-form-item>-->
          <!--          </div>-->
          <div class="content">
            <el-form-item label="项目名称" prop="projectname" verify>
              <el-input v-model="project.projectname" :maxlength="128" show-word-limit :disabled="disable"></el-input>
            </el-form-item>
          </div>
          <div class="from_input">
            <div class="row"   v-if="project.projecttype === '2'">
                <el-form-item label="采购人" prop="projectpcomid" verify>
                  <el-select v-model="project.projectpcomid" :clearable="true" :disabled="true" @change="getpUserList">
                    <el-option v-for="(item, index) in pcomList" :label="item.label" :value="item.value"
                              :key="index"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="联系人" prop="projectpuserid" verify>
                  <el-select v-model="project.projectpuserid" :clearable="true" :disabled="true" @change="getpUserTel">
                    <el-option v-for="(item, index) in puserList" :label="item.label" :value="item.value"
                              :key="index"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="联系电话" prop="projectptel" verify>
                  <el-input v-model="project.projectptel" :maxlength="20"  :disabled="true"></el-input>
                </el-form-item>
            </div>
          </div>
          <div class="from_input">
            <div class="row">

              <el-form-item label="采购预算(元)" prop="projectlimitamt" verify comdifyValdate>
                <el-input v-model="project.projectlimitamt"
                          @blur="inputMoney($event,'projectlimitamt')"
                          :maxlength="12"
                          :disabled="disable"
                ></el-input>
              </el-form-item>
              <!--            <div class="item_label">-->
              <!--              <el-form-item label="-"  prop="projecttopamt" verify :gt="0">-->
              <!--              <el-input v-model="project.projecttopamt" :maxlength="20" :disabled="disable"-->
              <!--                       ></el-input>-->
              <!--            </el-form-item>-->

              <!--            </div>-->
              <el-form-item label="">
                <el-checkbox v-model="project.projectysflg" :disabled="disable">采购公开预算</el-checkbox>
              </el-form-item>
              <el-form-item label="">
                <el-checkbox v-model="project.projecthsflg" :disabled="disable">含税报价</el-checkbox>
              </el-form-item>
            </div>
            <div class="row">
              <el-form-item label="报名费(元)" prop="projectbmamt" verify comdifyValdate :gt="100">
                <el-input v-model="project.projectbmamt" :maxlength="12" @blur="inputMoney($event,'projectbmamt')"
                          :disabled="disable"></el-input>
              </el-form-item>

              <el-form-item label="保证金(元)" prop="projectbzjamt" verify comdifyValdate>
                <el-input v-model="project.projectbzjamt" :maxlength="12" @blur="inputMoney($event,'projectbzjamt')"
                          :disabled="disable"></el-input>
              </el-form-item>
            </div>
            <div class="row" v-if="project.projecttype === '1'">
              <el-form-item label="采购人" prop="projectpcomid" verify>
                <el-select v-model="project.projectpcomid"  :filterable ="true" :clearable="true" :disabled="disable" @change="getpUserList">
                  <el-option v-for="(item, index) in pcomList" :label="item.label" :value="item.value"
                             :key="index"></el-option>
                </el-select>
              </el-form-item>


              <el-form-item label="联系人" prop="projectpuserid" verify>
                <el-select v-model="project.projectpuserid" :clearable="true" :filterable ="true" :disabled="disable" @change="getpUserTel">
                  <el-option v-for="(item, index) in puserList" :label="item.label" :value="item.value"
                             :key="index"></el-option>
                </el-select>
              </el-form-item>


              <el-form-item label="联系电话" prop="projectptel" verify>
                <el-input v-model="project.projectptel" :maxlength="20"  :disabled="disable"></el-input>
              </el-form-item>

            </div>

            <div class="row">
              <el-form-item label="成交方式" prop="projectdoneflg" verify>
                <el-select v-model="project.projectdoneflg" :clearable="true" :disabled="disable">
                  <el-option v-for="(item, index) in projectdoneflgList" :label="item.label" :value="item.value"
                             :key="index"></el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="">
                <el-checkbox v-model="project.projectisinvite" :disabled="disable">邀请采购</el-checkbox>
              </el-form-item>
            </div>
          </div>
          <!--<el-col :span="4">-->
          <!--<el-form-item label="">-->
          <!--<el-button  :disabled="project.projectisinvite?false:true" @click="invatedCom" >邀请供应商</el-button>-->
          <!--</el-form-item>-->
          <!--</el-col>-->

          <el-form-item label="开标地址">
            <el-input v-model="project.projectbidaddr" :maxlength="255" show-word-limit :disabled="disable"></el-input>
          </el-form-item>
          <el-form-item label="需求文件(内部)" v-if="+this.$store.getters.loginUser.comtype !== 3">
            <!--<upload-file-more :fileList="fileList" :isUplaodFlag="type === 3 ? 0 : 1" folderName="project"-->
                              <!--@changed='setfile' text="选择文件"></upload-file-more>-->
            <div class="file">
              <div>
                <upload-btn @changed='setfile' v-if="!disable" text="上传需求文件"></upload-btn>
              </div>
              <div v-if="appendList.length" class="filelist">
                <div v-for="(item,index) in appendList" :key="index" class="fileitem">
                  <div class="name" @click="downFile(item.appendurl)"><a :src="uploadAddr + item.appendurl">{{item.appendfilename}}</a>
                  </div>
                  <div class="btn" v-if="!disable" @click="delappend(item)"><span>删除</span></div>
                </div>
              </div>
            </div>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </Container>
</template>

<script>
  import request from '@/utils/request'
  import utils from '../../assets/js/utils'
  import uploadBtn from '../common/uploadBtn'
  import common from '@/mixin/common'
  import _ from 'lodash'
  const SUCCESS = 1
  export default {
    name: "projectform",
    mixins: [common],
    props: {
      cproject: Object,
      ctype: Number
    },
    data () {
      return {
        project: this.$route.params.form,
        type: Number(this.$route.params.type),
        disable: this.$route.params.type === 3 ? true : false,
        pmList: [],
        pmids: [],
        puserList: [],
        auserList: [],
        projectdoneflgList: [],
        acomList: [],
        pcomList: [],
        btnLoading: false,
        appendList: [],
        comsuserList:[],
        comList:{}
      }
    },
    created () {
    },
    mounted(){
        if (this.project.projectid) {
          this.init()
          this.getPmList()
        }
    },
    activated () {
      this.init()
      this.getProjectdoneflgList()
      this.getPcomList()
      this.getAcomList()
      this.getPmList()
      this.getcomsuserList()
      this.getcomList()
    },
    watch: {
      cproject () {
        this.init()
        this.getProjectdoneflgList()
        this.getPcomList()
        this.getAcomList()
        this.getPmList()
      }
    },
    components: {uploadBtn},
    computed: {
      uploadAddr () {
        return this.$store.getters.uploadAddr
      }
    },
    methods: {
      delappend(file) {
        this.$confirm(`确定移除 ${ file.appendfilename }？`, '提示', {
          type: 'warning'
        }).then(() => {
          let index = this.appendList.findIndex((val) => val.appendfilename === file.appendfilename)
          this.appendList.splice(index, 1)
        }).catch(() => {
        })
      },
      validateProjectcode(rul, val, callback) {
        this.project.projectcode = _.trim(val)
        this.validateData('项目编号不能重复','projectrec','projectid','projectcode', val, callback)
      },
      validateData (msg,tablename,fieldid,checkfield, checkval, callback) {
        request({
          url: '/validate/validateData',
          method: "post",
          data: {tablename,fieldid, checkfield, checkval: this.project[checkfield], id: this.project.projectid}
        }).then (res => {
          res === SUCCESS ? callback(Error(msg)) : callback()
        })
      },
      inputMoney (el, name) {
        let val = utils.delcommafy(el.target.value)
        var reg = /^[0-9]+.?[0-9]*$/
        if ((reg.test(val))) {
          this.project[name] = utils.getInputValue(el)
        }
      },
      async init () {
        this.$refs['ruleForm'].clearValidate()
        this.project = this.cproject || this.$route.params.form
        this.project.projectlimitamt = utils.comdify(this.project.projectlimitamt)
        this.project.projectbmamt = utils.comdify(this.project.projectbmamt)
        this.project.projectbzjamt = utils.comdify(this.project.projectbzjamt)
        this.type = this.ctype || Number(this.$route.params.type)
        this.disable = this.type === 3 ? true : false
        this.pmList = [{label: '', value: 0}]
        this.pmids = []
        this.projectdoneflgList = []
        this.acomList = []
        this.pcomList = []
        this.puserList = []
        this.auserList = []
        this.appendList = []
        this.comsuserList = []
        this.comList = []
        this.btnLoading = false
        if (this.project.projectid) {
          this.pmids = this.project.projectpmid.split(',').map(value => {
            return parseInt(value)
          })
          this.project.projectysflg = this.project.projectysflg == 1 ? true : false
          this.project.projecthsflg = this.project.projecthsflg == 1 ? true : false
          this.project.projectisinvite = this.project.projectisinvite == 1 ? true : false
          this.getpUserList(this.project.projectpcomid)
          if (this.project.projecttype === '1') {
            this.getaUserList(this.project.projectacomid)
          }
          this.getAppends()
        } else {
          this.project.projectno = await request({
            url: '/xmgl/project/genProjectNo',
            method: "post",
            data: {cosid: this.$store.getters.loginUser.cosid, genflg: 0}
          })
          this.project.projectcode = this.project.projectno
        }
        if (this.project.projecttype === '2' && this.type === 1) {
          // // 自采默认采购人和人
          this.project.projectpcomid = this.$store.getters.loginUser.comid
          await this.getpUserList(this.project.projectpcomid)
          this.project.projectpuserid = this.$store.getters.loginUser.userid
          this.project.projectptel = this.$store.getters.loginUser.usertel
          // await this.getpUserTel(this.project.projectpuserid)
        }
        if (this.project.projecttype === '1' && this.type === 1) {
          this.project.projectacomid = this.$store.getters.loginUser.comid
          await this.getaUserList(this.project.projectacomid)
          this.project.projectauserid = this.$store.getters.loginUser.userid
          this.project.projectatel = this.$store.getters.loginUser.usertel
          // await this.getaUserTel(this.project.projectauserid)
        }
      },
      async getAppends () {
        this.appendList = await request({
          method: 'get',
          url: '/ywgl/append/getAppendListByFromId',
          params: {appendfromid: this.project.projectid, appendfromtype: 7}
        })
      },
      async getProjectdoneflgList () {
        this.projectdoneflgList = await request({
          url: '/kfgl/syscode/getSysCodeList',
          method: "get",
          params: {syscode: 'projectdoneflg'}
        })
      },
      async getPmList () {
        let pmlist = await request({
          method: 'get',
          url: '/basic/pm/getPmTree',
          params: {cosid: this.$store.getters.loginUser.cosid}
        })
        this.pmList = pmlist.list

      },
      async getpUserList (comid) {
        this.puserList = await request({
          method: 'get',
          url: '/xtgl/user/getUserList',
          params: {comid: comid}
        })
      },
      async getaUserList (comid) {
        this.auserList = await request({
          method: 'get',
          url: '/xtgl/user/getUserList',
          params: {comid: comid}
        })
      },
      async getaUserTel (userid) {
        let user = this.auserList.find(item => (item.userid === userid))
        this.project.projectatel = user.usertel
      },
      async getpUserTel (userid) {
        let user = this.puserList.find(item => (item.userid === userid))
        this.project.projectptel = user.usertel
      },
      async getPcomList () {
        let model = {cosid: this.$store.getters.loginUser.cosid, comtype: '2'}
        //代理单位
        if (this.$store.getters.loginUser.comtype === '1') {
          if (this.project.projecttype === '2') {
            model.comid = this.$store.getters.loginUser.usercomid
          } else {
            model.comid = null
          }
        }
        //采购人
        if (this.$store.getters.loginUser.comtype === '2') {
          model.comid = this.$store.getters.loginUser.usercomid
        }
        this.pcomList = await request({
          method: 'get',
          url: '/ywgl/com/getComList',
          params: model
        })
        //业务员
        if(!this.project.projectsuserid){
          this.$set(this.project,'projectsuserid',this.pcomList[0].comsuserid)
        }
      },
      async getAcomList () {
        let model = {cosid: this.$store.getters.loginUser.cosid, comtype: '1'}
        //代理单位
        if (this.$store.getters.loginUser.comtype === '1') {
          model.comid = this.$store.getters.loginUser.usercomid
        }
        //采购人
        if (this.$store.getters.loginUser.comtype === '2') {
          if (this.project.projecttype === '2') {
            model.comid = this.$store.getters.loginUser.usercomid
          } else {
            model.comid = null
          }
        }
        this.acomList = await request({
          method: 'get',
          url: '/ywgl/com/getComList',
          params: model
        })
        // console.log('this.acomList[0]',this.acomList[0]);
        //业务员
        if(!this.project.projectsuserid){
          this.$set(this.project,'projectsuserid',this.acomList[0].comsuserid)
        }
      },
      // async setPic  (path) {
      //   this.project.projecturl = path.replace(this.uploadAddr,'')
      // },
      async pmchange (e) {
        let pmflg = this.pmList.forEach(key=>{

          if(key.pmid == e.toString()){
            this.$set(this.project,'projectchargefeetype',key.pmflg)
            // this.project.projectpmflg = key.pmflg
          }
        })
      },
      async addOrEdit () {
        this.btnLoading = true;
        this.submitForm('ruleForm').then(async() => {
          this.project.projectpmid = this.pmids.toString()
          this.project.projectcuserid = this.$store.getters.loginUser.userid
          this.project.projectmuserid = this.$store.getters.loginUser.userid
          this.project.projectysflg = this.project.projectysflg === true ? '1' : '0'
          this.project.projecthsflg = this.project.projecthsflg === true ? '1' : '0'
          this.project.projectisinvite = this.project.projectisinvite === true ? '1' : '0'
          this.project.projectchargefeetype = this.project.projectchargefeetype
          if (this.project.projecttype === '2') {
            this.project.projectacomid = null
            this.project.projectauserid = null
            this.project.projectatel = null
          }
          this.project.projectlimitamt = utils.delcommafy(this.project.projectlimitamt)
          this.project.projectbmamt = utils.delcommafy(this.project.projectbmamt)
          this.project.projectbzjamt = utils.delcommafy(this.project.projectbzjamt)

          this.project.appends = this.appendList
          let data = await request({
            url: '/xmgl/project/addOrEdit',
            method: "post",
            data: this.project
          })
          if (data.issuccess === 1) {
            this.close()
            this.$message.success('保存成功')
          } else {
            this.$message.error('保存失败')
          }
        }).catch(() => {
        })
        this.btnLoading = false
      },
      close () {
        let returnForm = 'projectIndex'
        if (this.project.projecttype === '2') {
          returnForm = 'projectZjIndex'
        }
        this.$store.commit('close_tab', {routeName: this.$route.name, vm: this, newRouteName: returnForm})
      },
      async setfile (path, filename) {
        // this.project.projecturl = path.replace(this.uploadAddr, '')
        // this.project.projectfilename = filename
        let append = {
          appendid: 0,
          appendfromid: 0,
          appendfromtype: '7',
          appendtype: '100',
          appendseq: this.appendList.length+1,
          appendfilecode: '',
          appendfilename: filename,
          appendurl: path.replace(this.uploadAddr,'')
        }
        this.appendList.push(append)
      },
      async getcomsuserList(){
        let query={
          comid: this.$store.getters.loginUser.usercomid
        }
        let res = await request({
          method: 'get',
          url: '/xtgl/user/getPageList',
          params: query
        })
        console.log(res)
        this.comsuserList = res.list
      },
      async getcomList(){
        //获取公司信息
        let data = await request({
          method: 'get',
          url: '/xtgl/user/getUser',
          params: {userid: this.$store.getters.loginUser.userid}
        })
        this.comList= data[0]
        this.project.projectbidaddr = this.comList.comaddr
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../../styles/filelist";
  .main {
    .from_input .el-input, .el-input .el-input__inner, .el-select {
      width: 200px;
    }
    .content .el-textarea__inner, .el-textarea, .el-input {
      width: 840px;
    }
    .file {
      display: flex;
      flex-direction: column;
      width: 50%;
    }
  }
</style>
